<template>
  <div class="hbox">
    <van-swipe :auto="4000" :speed="200" :showIndicators="true" :prevent="true">
      <van-swipe-item v-for="item in productInfo.imgList" :key="item.logid">
        <div
          :style="`background:url(${item.path}) center center no-repeat;background-size:cover`"
        ></div>
      </van-swipe-item>
    </van-swipe>
    <div class="main-part" :class="{ active: productInfo.status == '待签收' }">
      <div class="white-box">
        <div class="title">
          <div>{{ productInfo.nameZh }}</div>
        </div>
        <div class="content">
          <div class="name">系列：</div>
          <div class="info">{{ productInfo.descType }}</div>
        </div>
        <div class="content">
          <div class="name">产品编号：</div>
          <div class="info">{{ productInfo.productNo }}</div>
        </div>
        <div class="content">
          <div class="name">样品编号：</div>
          <div class="info">{{ productInfo.sampleNo }}</div>
        </div>
        <div class="content" v-if="productInfo.sampleCostInstance.sampleCost">
          <div class="name">样品费用：</div>
          <div class="info">
            {{
              productInfo.sampleCostInstance.sampleCost
                ? "¥" + productInfo.sampleCostInstance.sampleCost
                : "暂无"
            }}
          </div>
          <div
            class="voucher"
            v-if="productInfo.sampleCostInstance.addition"
            @click="preview"
          >
            支付凭证
          </div>
        </div>
        <div class="content" v-if="productInfo.sampleCostInstance.expressCost">
          <div class="name">快递费用：</div>
          <div class="info">
            {{
              productInfo.sampleCostInstance.expressCost
                ? "¥" + productInfo.sampleCostInstance.expressCost
                : "暂无"
            }}
          </div>
          <div
            class="voucher active"
            v-if="productInfo.sampleCostInstance.exAddition"
            @click="expreview"
          >
            支付凭证
          </div>
        </div>
        <div class="status">{{ productInfo.status }}</div>
      </div>
      <div class="white-box">
        <div class="title active">
          <div>工厂信息</div>
          <div class="cropper icon-gongchang"></div>
        </div>
        <div class="content active">
          <div class="name">供应商：</div>
          <div class="info">{{ productInfo.supName }}</div>
        </div>
        <div class="content active">
          <div class="name">打样工厂：</div>
          <div class="info">{{ productInfo.proofFactory }}</div>
        </div>
        <div class="content active">
          <div class="name">通知打样：</div>
          <div class="info">{{ productInfo.addProofTime }}</div>
        </div>
        <div class="content active">
          <div class="name">寄出样品：</div>
          <div class="info">
            {{ productInfo.sendTime ? productInfo.sendTime : "暂无" }}
          </div>
        </div>
      </div>
      <div class="white-box">
        <div class="title active">
          <div>业务员信息</div>
          <div class="iconfont icon-renyuan"></div>
        </div>
        <div class="content active">
          <div class="name">业务员：</div>
          <div class="info">{{ productInfo.businessUser }}</div>
        </div>
        <div class="content active" v-if="productInfo.signatory">
          <div class="name">签收人：</div>
          <div class="info">{{ productInfo.signatory }}</div>
        </div>
        <div class="content active" v-if="productInfo.signTime">
          <div class="name">确认收货：</div>
          <div class="info">{{ productInfo.signTime }}</div>
        </div>
      </div>
    </div>
    <div
      class="success-button"
      v-if="
        productInfo.status == '待签收' &&
        (permissions.indexOf('pur:prf:sign') != -1 ||
          permissions.indexOf('*:*:*') != -1)
      "
    >
      <mt-button size="large" type="primary" @click="confirmReceipt"
        >确认收货</mt-button
      >
    </div>
  </div>
</template>

<script>
import { productApi } from "../api/api";
import { ImagePreview } from "vant";
const pageApi = new productApi();
export default {
  data() {
    return {
      productInfo: {
        sampleCostInstance: {
          sampleCost: "",
          addition: "",
          exAddition: "",
        },
        imgList: [],
      },
      permissions: [],
    };
  },
  methods: {
    async confirmReceipt() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否确认收货",
          confirmButtonColor: "#3F996C",
        })
        .then(async (action) => {
          let res = await pageApi.signSample(this.$route.query.proofId);
          if (res.success) {
            this.$notify({
              message: res.message,
              type: "success",
              duration: 5000,
            });
            this.getSignInfo();
          } else {
            this.$notify({
              message: res.message,
              type: "danger",
              duration: 5000,
            });
          }
        });
    },
    async sobuyGetInfo() {
      this.permissions = await pageApi.sobuyGetInfo(this.$route.query.proofId);
    },
    async getSignInfo() {
      let res = await pageApi.getSignInfo(this.$route.query.proofId);
      (res.sampleCostInstance = res.sampleCostInstance
        ? res.sampleCostInstance
        : {
            sampleCost: "",
            addition: "",
            exAddition: "",
          }),
        (this.productInfo = res);
    },
    preview() {
      let imgList = [];
      if (this.productInfo.sampleCostInstance.addition) {
        imgList.push(this.productInfo.sampleCostInstance.addition.path);
      }
      ImagePreview(imgList);
    },
    expreview() {
      let imgList = [];
      if (this.productInfo.sampleCostInstance.exAddition) {
        imgList.push(this.productInfo.sampleCostInstance.exAddition.path);
      }
      ImagePreview(imgList);
    },
  },
  created() {},
  mounted() {
    this.getSignInfo();
    this.sobuyGetInfo();
  },
};
</script>

<style lang="scss" scoped>
body {
  background: #f1f1f1;
}
.hbox {
  background: #f1f1f1;
  min-height: calc(100vh - 88px);
}
.van-swipe-indicator {
  width: 14px;
  height: 14px;
  border: 14px;
  background: #dbdbdb;
  margin: 0 4.5px;
  opacity: 1;
  &.is-active {
    background: #3f996c;
  }
}
.mint-button {
  border-radius: 0;
  padding-top: 5px;
  background: #f1f1f1;
}
.success-button {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 140px;
  box-sizing: border-box;
  padding: 0 30px;
  background: #fff;
}
.mint-button--primary {
  background: $base_color;
  border-radius: 86px;
  height: 86px;
  font-size: 30px;
  margin-top: 28px;
}
.van-swipe {
  width: 100%;
  height: 563px;
  .van-swipe-item {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: #ddd;
    > div {
      width: 100%;
      height: 100%;
      background: #000;
    }
  }
}
.main-part {
  padding: 30px 30px 30px;
  text-align: left;
  background: #f1f1f1;
  &.active {
    padding-bottom: 200px;
  }
  .crumbs {
    color: #333;
    font-size: 14px;
    padding: 10px 0;
  }
  .white-box {
    @include white_box;
    margin-top: 30px;
    position: relative;
    &:first-child {
      margin-top: 0;
    }
    .title {
      font-weight: bold;
      color: #303133;
      margin-bottom: 32px;
      font-size: 32px;
      line-height: 36px;
      position: relative;
      &.active {
        padding-left: 45px;
        .iconfont {
          position: absolute;
          left: 0;
          top: 33%;
          transform: translateY(-50%);
          width: 30px;
          height: 30px;
          font-size: 30px;
          color: #3f996c;
        }
        .cropper {
          position: absolute;
          left: 0;
          top: 33%;
          transform: translateY(-50%);
          width: 30px;
          height: 30px;
          font-size: 30px;
          color: #3f996c;
        }
      }
    }
    .content {
      color: #666;
      font-size: 24px;
      margin-bottom: 20px;
      line-height: 26px;
      display: flex;
      color: #4d4d4d;
      position: relative;
      .name {
        width: 120px;
        text-align: right;
        flex-shrink: 0;
      }
      .info {
        width: 100%;
      }
      &.active {
        font-size: 32px;
        .name {
          width: 180px;
          color: #999999;
        }
        .info {
          color: #333;
        }
      }
      &.active2 {
        font-size: 32px;
        .name {
          width: 129px;
          color: #999999;
        }
        .info {
          color: #333;
        }
      }
    }
    .status {
      position: absolute;
      color: #999999;
      font-size: 24px;
      right: 20px;
      top: 20px;
    }
    .voucher {
      position: absolute;
      color: #3f996c;
      font-size: 24px;
      right: 0px;
      bottom: 0px;
      text-decoration: underline;
    }
  }
}
</style>
